module.exports = __webpack_public_path__ + "img/zhutishuoming.3454229a.png";